<template>
  <div class="exchange-input-amount">
    <input
      v-mask="mask"
      :value="props.value"
      class="exchange-input-amount__input"
      placeholder="0.00"
      autocomplete="off"
      autocapitalize="off"
      autocorrect="off"
      spellcheck="false"
      pattern="^[0-9]+([\.,][0-9]+)?$"
      inputmode="decimal"
      :style="{ width: `${Math.max(props.value.length, 4)}ch` }"
      @accept="onAccept"
    />
    <span class="exchange-input-amount__currency">{{ currency }}</span>
  </div>
</template>

<script lang="ts" setup>
import { IMaskDirective as vMask } from 'vue-imask';

const props = defineProps<{
  value: string,
  currency: string,
}>();

const emit = defineEmits<{
  (e: 'input', value: string): void,
}>();

const mask = {
  mask: Number,
  scale: 2,
  radix: '.',
  mapToRadix: ['.', ','],
  min: 0,
};

const onAccept = (e) => {
  while (e.detail.value.match(/^0\d/) || e.detail.value.startsWith('.')) {
    e.detail.value = e.detail.value.slice(1);
  }

  const value = e.detail.value;

  if (props.value !== value && Number.parseFloat(props.value) !== Number.parseFloat(value)) {
    emit('input', value);
  }
};
</script>

<style scoped lang="scss">
@import "@scss-vars";

.exchange-input-amount {
  display: grid;
  grid-gap: rem(4);
  grid-template-columns: 1fr max-content;
  align-items: center;
  border-radius: rem(6);
  border: 1px solid transparent;
  font-family: $font-bold;
  font-size: rem(14);
  line-height: rem(16);
  transition: border-color .2s linear;

  &:focus-within {
    border-color: $black-10;
    padding: 0.125rem 0.25rem;
  }

  &__input {
    min-width: 1ch;
    max-width: 10ch;
    padding: 2px 0;
    border-bottom: 1px solid $black-15;
    border-radius: 0;
    box-shadow: none;
    transition: border-color .2s linear, min-width .5s linear;
    outline: none;
    font-size: rem(14);
    line-height: rem(16);
  }

  &:focus-within &__input {
    border-color: transparent;
  }

  &__currency {
    color: $black;
    margin-left: 4px;
    transition: color 0.2s linear;
  }

  &:focus-within &__currency {
    color: $black-30;
  }
}
</style>